import { Directive, HostListener, Input, NgZone, Optional } from '@angular/core';
import { NzModalComponent, NzModalRef } from 'ng-zorro-antd/modal';

@Directive({
  selector: '[cwtCloseModal]'
})
export class CloseModalDirective {

  @Input('cwtCloseModal') data: any;

  constructor(
    @Optional() private modalComponent: NzModalComponent,
    @Optional() private modalRef: NzModalRef
  ) { }

  @HostListener('click', ['$event'])
  public close(event: Event) {
    if (!this.modalRef && !this.modalComponent) return;
    event?.stopPropagation();
    event?.preventDefault();
    if (this.modalComponent) {
      this.modalComponent.close(this.data);
    } else if (this.modalRef) {
      this.modalRef.close(this.data);
    }
  }
}
